module.exports = __webpack_public_path__ + "static/media/user-minus.b5397499.svg";